import { BaseComponent } from '../../base-component';
import { ImagesSubComponent } from './images.sub.component';
import { AlternateImagesSubComponent } from './alternate-images/alternate-images.sub.component';
import { MainImageSubComponent } from './main-image/main-image.sub.component';
import { LightboxSubComponent } from './lightbox/lightbox.sub.component';
import { VideoLinkSubComponent } from './video-link/video-link.sub.component';
import { ComboPromoButtonSubComponent } from './combo-promo-button/combo-promo-button.sub.component';
import { ProductRoomFitSubComponent } from './product-room-fit/product-room-fit.sub.component';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export type ImagesState = {
    videoAssetKey?: string;
    videoIndex: number;
    imageIds: string[];
};

export class ImagesComponent extends BaseComponent {
    public rootSelector = '.js_pdp_images';
    private state: ImagesState = {
        videoIndex: -1,
        imageIds: [],
    };
    private subComponents: ImagesSubComponent[] = [];

    private async addSubComponent(subComponent: ImagesSubComponent) {
        if (this.logger) {
            await subComponent.setLogger(this.logger);
        }
        this.subComponents.push(subComponent);
    }

    public async init(): Promise<void> {
        await this.addSubComponent(new MainImageSubComponent(this.state));
        await this.addSubComponent(new AlternateImagesSubComponent(this.state));
        await this.addSubComponent(new LightboxSubComponent(this.state));
        await this.addSubComponent(new ComboPromoButtonSubComponent(this.state));
        await this.addSubComponent(new VideoLinkSubComponent(this.state));
        await this.addSubComponent(new ProductRoomFitSubComponent(this.state));

        await Promise.all(this.subComponents.map(subComponent => subComponent.init()));
    }

    public async onHtmlLoaded(): Promise<void> {
        this.state.videoAssetKey = this.getRootElement().dataset.videoAssetKey;
        this.state.imageIds = this.getImageIds();
        this.state.videoIndex = this.state.videoAssetKey ? Math.min(this.state.imageIds.length, 4) : -1;
        await Promise.all(this.subComponents.map(subComponent => subComponent.onHtmlLoaded()));
        this.trackWhitespaceBelowImageModule();
        this.registerDeviceOrientationListener();
    }

    private getImageIds() {
        const slideElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js_pdp_main-image__slide-content');
        return Array.from(slideElements).map(slideElement => slideElement.dataset.imageId as string);
    }

    private calculateWhiteSpace(): number {
        const rootElement = this.getRootElement();
        const wrapperElement = this.getChildElement('.js_pdp_images__wrapper');
        const rootElementHeight = rootElement.getBoundingClientRect().height;
        const wrapperElementHeight = wrapperElement.getBoundingClientRect().height;
        return rootElementHeight - wrapperElementHeight;
    }

    private trackWhitespaceBelowImageModule(): void {
        trackView({
            'wk.product_WhiteSpace': [String(Math.floor(this.calculateWhiteSpace()))],
        });
    }

    private registerDeviceOrientationListener(): void {
        if (screen && screen.orientation) {
            screen.orientation.addEventListener('change', _event => {
                this.trackOrientationChange();
            });
        }
    }

    /*                 */
    public trackOrientationChange(): void {
        if (screen && screen.orientation && screen.orientation.type.startsWith('landscape')) {
            trackEvent({
                product_Zoom: ['landscape'],
            });
        }
    }
}
